export default __webpack_public_path__ + "static/media/react.ebb56ca4.png";